import { useCallback } from 'react';

import qs from 'qs';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useCurrentUserId, useSessionUuid } from 'src/app/shared/hooks/session';
import type { ShareAction, ShareChannel } from 'src/app/shared/hooks/share';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';

export function useQRCodeShare(): ShareAction {
	const { data } = useStarterDashboardV2PageData();
	const { resolveUrl } = useUtilityContext();
	const sourceLocation = useQueryParamValue('source_location');
	const sessionUuid = useSessionUuid();
	const currentUserId = useCurrentUserId();

	const getContent = (_channel: ShareChannel) => '';

	const getUrl = useCallback(
		(_channel: ShareChannel) => {
			const utmParams = qs.stringify(
				{
					utm_source: 'share_petition',
					utm_medium: 'qr_code',
					utm_campaign: 'starter_dashboard',
					recruited_by_id: sessionUuid,
					recruiter: currentUserId,
				},
				{ encodeValuesOnly: true },
			);
			return resolveUrl(`/p/${data.petition.slug}?${utmParams}`);
		},
		[currentUserId, data.petition.slug, resolveUrl, sessionUuid],
	);

	const getTrackingData = useCallback(
		(_channel: ShareChannel) => ({
			view_context: 'starter_dashboard',
			own_petition: data.petition.user.id === currentUserId,
			context: 'starter_dashboard',
			petition_id: `petition_${data.petition.id}`,
			source_location: sourceLocation,
		}),
		[currentUserId, data.petition.id, data.petition.user.id, sourceLocation],
	);

	const trackingEventName = 'share_petition';
	const channels = ['qrcode'] as const;

	const options = { trackingEventName, getUrl, getTrackingData, getContent };

	return useAvailableShareActions(channels, options)[0];
}
